import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_NAME, SITE_URL } from '../../config/seo';

const LocalBusinessJsonLd = () => {
    const schema = {
        '@context': 'https://schema.org',
        '@type': 'HairSalon',
        name: SITE_NAME,
        url: SITE_URL,
        image: `${SITE_URL}/og-image.png`,
        telephone: '+7-915-189-70-33',
        email: 'salon.l.e.v@yandex.ru',
        address: {
            '@type': 'PostalAddress',
            streetAddress: 'Смоленский бульвар, 22/14',
            addressLocality: 'Москва',
            addressCountry: 'RU',
        },
        openingHoursSpecification: [
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: [
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                    'Sunday',
                ],
                opens: '10:00',
                closes: '21:00',
            },
        ],
        priceRange: '₽₽',
        inLanguage: 'ru-RU',
    };

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(schema)}</script>
        </Helmet>
    );
};

export default LocalBusinessJsonLd;
